/**
 * Finish Item Deduplication
 * Hides h3 headings with "Wood - [Color]" pattern when consecutive items have the same pattern
 */

class FinishItemDeduplication {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.deduplicateHeadings());
    } else {
      this.deduplicateHeadings();
    }
  }

  /**
   * Check if an h3 element starts with "Wood -"
   */
  isWoodHeading(h3Element) {
    if (!h3Element) return false;
    const text = h3Element.textContent.trim();
    return text.startsWith('Wood -');
  }

  /**
   * Find the h3 element within a finish-item's description
   */
  findHeadingInItem(finishItem) {
    const descriptionDiv = finishItem.querySelector('.text-sm.text-gray-700');
    if (!descriptionDiv) return null;
    
    const h3 = descriptionDiv.querySelector('h3');
    return h3;
  }

  /**
   * Main function to deduplicate headings
   */
  deduplicateHeadings() {
    const finishItems = document.querySelectorAll('.finish-item');
    
    if (finishItems.length === 0) return;

    // Iterate through finish items and check consecutive pairs
    for (let i = 0; i < finishItems.length - 1; i++) {
      const currentItem = finishItems[i];
      const nextItem = finishItems[i + 1];

      const currentH3 = this.findHeadingInItem(currentItem);
      const nextH3 = this.findHeadingInItem(nextItem);

      // If both current and next items have "Wood -" headings, hide the current one
      if (this.isWoodHeading(currentH3) && this.isWoodHeading(nextH3)) {
        currentH3.style.display = 'none';
        // Add a data attribute to track that this was hidden by deduplication
        currentH3.setAttribute('data-deduplicated', 'true');
      }
    }
  }

  /**
   * Reset all hidden headings (useful if you need to re-run the logic)
   */
  reset() {
    const hiddenHeadings = document.querySelectorAll('h3[data-deduplicated="true"]');
    hiddenHeadings.forEach(h3 => {
      h3.style.display = '';
      h3.removeAttribute('data-deduplicated');
    });
  }
}

// Initialize when script loads
const finishItemDeduplication = new FinishItemDeduplication();

// Export for potential use in other scripts
if (typeof module !== 'undefined' && module.exports) {
  module.exports = FinishItemDeduplication;
}

